import { LABELS } from "~/resources/Labels";
import { TableHeaderType } from "../types/TableHeaderType";

export const ScriptsTypeHeader: TableHeaderType[] = [
    {
      label: "ID",
      key: 'id',
      id: 'id',
      sortable: true,
    },
    {
      label: LABELS.Name,
      key: "name",
      id: 'name',
      sortable: true,
    },
    {
      label:LABELS.Description,
      key: "description",
      id: 'description',
      sortable: false,
    },

    {
      id: 'actions',
      label:'',
      alignment: '',
      sortable: false,
      key: '',
    },
  ];
